var map = {
	"./address/index.js": 1081,
	"./contact/index.js": 1084,
	"./gallery/index.js": 1089,
	"./image/index.js": 1092,
	"./link/index.js": 1096,
	"./page/index.js": 1100,
	"./pdf/index.js": 1103,
	"./text/index.js": 1107,
	"./title/index.js": 1110,
	"./youtube/index.js": 1113
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2171;


//////////////////
// WEBPACK FOOTER
// ./src/modules/edito/plugins ^\.\/.*\/index\.js$
// module id = 2171
// module chunks = 0